// Operator details shared by the Terms and Privacy pages.
export const OPERATOR_NAME = "STELLARIS Space Adventures UG (haftungsbeschränkt)";
export const OPERATOR_ADDRESS = "Schulstraße 16, 94469 Deggendorf, Germany";
export const CONTACT_EMAIL = "info@stellarisspace.com";
export const LEGAL_LAST_UPDATED = "Last updated: 30 September 2026";
